import "core-js/modules/web.timers.js";
// Based on https://www.joshwcomeau.com/snippets/javascript/debounce/

export var debounce = function debounce(callback, wait) {
  var timeoutId = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(function () {
      callback.apply(void 0, args);
    }, wait);
  };
};